import React, { useEffect, useState } from 'react';
import ExpanderContainer from '../../../components/expanderContainer/ExpanderContainer';
import useTranslation from '../../../../hooks/translation/useTranslation';
import { getScheduleDetailsByIdService } from '../../../../../services/customer/scheduleServices';
import ScheduleStop from './ScheduleStop';

function ScheduleItemsDetails({
  expanded, scheduleId, containerWidth, stationsMap,
}) {
  const [scheduleDetails, setScheduleDetails] = useState(null);
  const { trans } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      const res = await getScheduleDetailsByIdService(scheduleId);
      res?.sort(
        (a, b) => a.index - b.index,
      );
      setScheduleDetails(res?.filter((stop) => stop?.isStandingStation));
    };
    if (expanded && !scheduleDetails) {
      fetchData();
    }
  }, [expanded]);

  return (
    <ExpanderContainer
      expanded={expanded}
      className="w-fit relative rounded-2xl min-w-full"
    >
      <div
        style={{
          maxWidth: containerWidth,
        }}
        className="mt-1 shadow-xl rounded-2xl px-4 py-10 flex flex-col gap-4"
      >
        <h3
          className="text-base m-0"
        >
          {trans('list_of_stations')}
        </h3>
        <div className="flex flex-col gap-3 w-full">
          <div className="flex gap-2 overflow-x-auto w-full">
            {scheduleDetails?.map((stop, index) => (
              <ScheduleStop
                key={stop.id}
                data={stop}
                isLast={index === scheduleDetails.length - 1}
                stationsMap={stationsMap}
              />
            ))}
          </div>
          <div className="w-full bg-black h-[1px] mt-2" />
        </div>
      </div>
    </ExpanderContainer>
  );
}

export default ScheduleItemsDetails;
